import axios from 'axios';

// 환경 변수에서 설정값 로드 (없으면 undefined → 기존 방식 사용)
const ENV_API_HOST = process.env.VUE_APP_API_HOST || undefined;
const ENV_WS_SERVER = process.env.VUE_APP_WS_SERVER || undefined;
const SERVICE_URL = process.env.VUE_APP_SERVICE_URL || "http://service.wows.co.kr";

const remote = {
    host: ENV_API_HOST,
    timeout: 120000,
  },
  METHOD = {
    GET: 'get',
    POST: 'post',
    PUT: 'put',
    DELETE: 'delete',
  };

export default {
  METHOD,
  getUrl(url) {
    return (typeof remote.host === 'string' ? 'http://' + remote.host : '') + url;
  },
  getWowserviceUrl(url) {
    return `${SERVICE_URL}${url}`;
  },
  request(option) {
    if (typeof option.timeout !== 'number') {
      option.timeout = remote.timeout;
    }

    return axios(option);
  },
  // socketIO port : 13000
  wsServer: ENV_WS_SERVER || (location.hostname + ':' + 13000),
};
